"use client";

import Icon from "@/components/ui/AppIcon";

export default function TrustBadges() {
  const badges = [
    {
      icon: "LockClosedIcon",
      label: "SSL Secured",
      sub: "256-bit encryption",
      color: "text-accent-emerald",
    },
    {
      icon: "ShieldCheckIcon",
      label: "PCI Compliant",
      sub: "Level 1 certified",
      color: "text-accent-cyan",
    },
    {
      icon: "CreditCardIcon",
      label: "Secure Payment",
      sub: "Powered by Przelewy24",
      color: "text-accent-purple",
    },
    {
      icon: "ArrowPathIcon",
      label: "30-Day Refund",
      sub: "No questions asked",
      color: "text-accent-gold",
    },
  ];

  return (
    <div className="mt-8 pt-8 border-t border-white/5">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {badges?.map((badge) => (
          <div
            key={badge?.label}
            className="flex flex-col items-center text-center gap-2 p-4 bg-bg-card border border-white/5 rounded-2xl"
          >
            <Icon name={badge?.icon} size={22} className={badge?.color} />
            <div>
              <p className="text-white text-xs font-semibold">{badge?.label}</p>
              <p className="text-gray-600 text-[10px] mt-0.5">{badge?.sub}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
